<template>
    <div class="pt-3">
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto form-inline">
                <!--                <multiselect-->
                <!--                    v-if="canView()"-->
                <!--                    v-model="search.sale"-->
                <!--                    class="form-control border-0"-->
                <!--                    :options="seller"-->
                <!--                    :customLabel="saleLabel"-->
                <!--                    placeholder="กรุณาเลือกเซลล์"-->
                <!--                    :show-labels="false"-->
                <!--                    @input="filter()"-->
                <!--                    track-by="sale_id">-->
                <!--                </multiselect>-->
                <!--                &nbsp-->
                <!--                <button @click="showQuotaModal()"-->
                <!--                        class="btn btn-warning my-2 my-sm-0"-->
                <!--                        type="button">-->
                <!--                    <icon name="plus"></icon>-->
                <!--                    จองโควต้า-->
                <!--                </button>-->
            </div>
        </nav>
        <!--        <nav class="navbar navbar-expand-lg navbar-light">-->
        <!--            <div class="ml-auto">-->
        <!--                <form class="form-inline my-2 my-lg-0">-->
        <!--                    -->
        <!--                </form>-->
        <!--            </div>-->
        <!--        </nav>-->
        <div class="col-12 table-responsive">
            <table class="table table-bordered" style="text-align: center">
                <thead>
                <tr>
                    <th scope="col">วันที่</th>
                    <th scope="col">เซล</th>
                    <th scope="col">สินค้า</th>
                    <th scope="col">จำนวนที่เกิน</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(x,ix) in list">
                    <td>{{ x.created_at | moment('DD/MM/YYYY hh:mm:ss') }}</td>
                    <td>{{ x.sale_name }}</td>
                    <td>{{ x.sku + ' ' + x.name }}</td>
                    <td>{{ x.amount }}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <b-modal hide-footer hide-header ref="loading">
            <loading :msg="msg" :status="status" @submit="hideLoadingModal"></loading>
        </b-modal>
        <!--        <b-modal size="l" hide-header hide-footer ref="quota_modal" no-close-on-backdrop>-->
        <!--            <h4 class="text-center">จองโควต้า</h4>-->
        <!--            <div class="row form-group">-->
        <!--                <div class="col-4 text-right">-->
        <!--                    <label>วันที่จอง</label>-->
        <!--                </div>-->
        <!--                <div class="col-6">-->
        <!--                    <date-picker v-model="quota.date"-->
        <!--                                 placeholder="วันที่จอง"-->
        <!--                                 :disabled="true"-->
        <!--                                 :format="changeFormat"-->
        <!--                                 :lang="lang">-->
        <!--                    </date-picker>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--            <div class="row form-group">-->
        <!--                <div class="col-4 text-right">-->
        <!--                    <label>รหัสสินค้า</label>-->
        <!--                </div>-->
        <!--                <div class="col-6">-->
        <!--                    <multiselect-->
        <!--                        v-model="quota.product"-->
        <!--                        :options="optionProducts"-->
        <!--                        track-by="id"-->
        <!--                        :show-labels="false"-->
        <!--                        :custom-label="LabelNameSku"-->
        <!--                        placeholder="รหัสสินค้า">-->
        <!--                    </multiselect>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--            <div class="row form-group">-->
        <!--                <div class="col-4 text-right">-->
        <!--                    <label>จำนวนที่จอง</label>-->
        <!--                </div>-->
        <!--                <div class="col-6">-->
        <!--                    <input type="number" placeholder="0.00" v-model="quota.amount" class="form-control"/>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--            <div class="col text-center">-->
        <!--                <button class="btn btn-success" @click="submit">บันทึก</button>&nbsp;-->
        <!--                <button class="btn btn-outline-secondary" @click="hideQuotaModal">ยกเลิก</button>&nbsp;-->
        <!--            </div>-->
        <!--        </b-modal>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";

import {canViewSuperAdmin} from "../../util/Permissions";

import Loading from "../Utility/Loading";
import DatePicker from "vue2-datepicker";
import BillingModal from "@/components/Accounting/Billing/BillingModal.vue";

export default {
    name: "quota-sale-create",
    components: {
        BillingModal,
        Loading,
        Multiselect,
        DatePicker
    },
    data() {
        return {
            msg: 'กำลังโหลดข้อมูล',
            status: 1,
            list: [],
        };
    },
    created() {
        this.index({page: 1});
    },
    computed: {
        canViewSuperAdmin,
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
            optionProducts: (state) => {
                return state.Products.product_all
            },
            seller: state => {
                return state.Seller.data;
            },
            optionProductType: state => {
                return state.ProductType.data;
            },
        })
    },
    methods: {
        // canView() {
        //     let qc = ['10223', '10228', '10701', '20648', '20701', '20726', '20729', '20655', '20708', '20683']
        //     let admin = ['20533']
        //     return (qc.includes(this.user.username) || admin.includes(this.user.username) || canViewSuperAdmin())
        // },
        LabelNameSku(option) {
            return `${option.sku} - ${option.name}`
        },
        LabelName(option) {
            return `${option.type_code} - ${option.name}`
        },
        saleLabel(option) {
            return `${option.sale_id} - ${option.name}`
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },

        index(data) {
            let payload = {
                page: data.page,
            }
            this.$store.dispatch('Products/listQuotaHistory', payload).then(res => {
                this.list = res.data
                this.hideLoadingModal()
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.text-red {
    color: red;
}
</style>
